import React from "react";

const Toggle = ({
  className,
  active = false,
  onChange = () => {},
  displayState = false,
}) => {
  return (
    <span className={className}>
      <label className="switch">
        <input
          role="checkbox"
          type="checkbox"
          onChange={e => {
            onChange(e);
          }}
          checked={active}
        />
        <span className={`slider round${className ? ` ${className}` : ""}`} />
        {displayState && (
          <span
            className="text-sm relative cursor-pointer"
            style={{
              left: active ? 8 : 28,
            }}
          >
            {active ? "on" : "off"}
          </span>
        )}
      </label>
    </span>
  );
};

export default Toggle;
